<template>
  <div>
    <v-card class="rounded-lg shadow">
      <v-overlay :value="overlay" absolute color="white" opacity="0.5">
        <v-progress-circular
            color="primary"
            indeterminate
            size="50"
        ></v-progress-circular>
      </v-overlay>

      <v-card-title>
        <div>
          <v-text-field
              v-model="keyword"
              hint="Appuyez sur ↵ Entrée pour rechercher"
              clearable
              @keydown.enter="getItems"
              @click:clear="[keyword=null,getItems()]"
              append-icon="mdi-magnify"
              dense
              filled
              persistent-hint
              placeholder="Recherche..."
              rounded
              single-line

          />
        </div>
        <v-spacer/>

        <v-btn color="grey"
               class="rounded-lg mr-2"
               text
               @click=getItems>
          <v-icon left>mdi-refresh</v-icon>
          Mettre à jour
        </v-btn>

        <v-btn text
               @click="$refs.importDialogRef.open('target')"
               class="rounded-lg  v-btn--active mr-2"
               depressed
               color="gifty"
        >
          <v-icon left>mdi-account-multiple-plus</v-icon>
          Import utilisateurs + objectifs
        </v-btn>

        <v-btn
            @click="$refs.importDialogRef.open('achieved')"
            class="rounded-lg"
            depressed
            color="gifty"
            dark
        >
          <v-icon left>mdi-chart-line</v-icon>
          Mise à jour des réalisés
        </v-btn>

      </v-card-title>

      <v-divider/>

      <v-card-text v-if="isLoading">
        <v-skeleton-loader type="table"/>
      </v-card-text>

      <div v-else>
        <v-card-text class="pa-0">

          <v-simple-table v-if="users.length">
            <template v-slot:default>
              <thead>
              <tr>
                <th>Nom d'utilisateur</th>
                <th>Téléphone</th>
                <th>Objectif</th>
                <th>Type d'objectif</th>
                <th class="text-center">Progression</th>
              </tr>
              </thead>

              <tbody>
              <tr v-for="(item, index) in users" :key="index">

                <td class="font-weight-bold">
                  {{ item.user?.name || '-' }}
                </td>

                <td>
                  {{ item.user?.phone || '-' }}
                </td>

                <td class="font-weight-medium">
                  {{ item.objective?.name?.fr }}
                </td>

                <td>
                  {{ item.objective?.type === 'amount' ? 'Montant' : 'Quantité' }}
                </td>

                <td  :style="{width: '160px'}">
                  <div class="d-flex flex-column">

                    <div class="d-flex justify-space-between align-center mb-1">
                      <small class="font-weight-bold grey--text text--darken-1 text--lighten-1">
                        {{ item.achieved || 0 }} / {{ item.target || 0 }}
                      </small>

                      <v-chip
                          x-small
                          dark
                          :color="item.percentage >= 100 ? 'success' : 'warning'"
                      >
                        {{ item.percentage || 0 }}%
                      </v-chip>
                    </div>

                    <v-progress-linear striped
                                       :style="{width: '160px'}"
                                       :value="item.percentage || 0"
                                       height="6"
                                       rounded
                                       :color="item.percentage >= 100 ? 'success' : 'gifty'"
                                       background-color="grey lighten-3"
                    ></v-progress-linear>

                  </div>
                </td>

              </tr>
              </tbody>
            </template>
          </v-simple-table>

          <div v-else>
            <NoResults @reload="getItems"/>
          </div>
        </v-card-text>

        <v-divider v-if="total > 10"/>

        <v-card-actions v-if="total > 10">

          <div :style="{width: '120px'}">
            <v-select v-model="perPage"
                      :items="[10,20,30,50,100]"
                      dense
                      hide-details
                      label="Ligne par page"
                      outlined></v-select>
          </div>

          <v-spacer/>

          <v-pagination v-model="pagination.current"
                        :length="pagination.total"
                        circle
                        total-visible="8"
                        @input="getItems"></v-pagination>

        </v-card-actions>

      </div>
    </v-card>


    <ImportDialog ref="importDialogRef" :objectives="objectives" @refresh="getItems"/>


  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import NoResults from "@/components/NoResults";
import ImportDialog from "./ImportDialog";

export default {
  components: {NoResults, ImportDialog},
  data() {
    return {
      keyword: '',
      id: '',
      overlay: false,
      isLoading: false,
      users: [],
      objectives: [],

      total: 0,
      perPage: 10,
      pagination: {
        current: 1,
        total: 0
      },
    };
  },
  methods: {
    getItems() {
      this.isLoading = true
      HTTP.get('/v1/opus/objectives/users?page=' + this.pagination.current, {
        params: {
          perPage: this.perPage,
          keyword: this.keyword
        }
      }).then(res => {
        this.pagination.current = res.data.data.current_page;
        this.pagination.total = res.data.data.last_page;
        this.total = res.data.data.total;

        this.users = res.data.data.data

        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    getObjs() {
      HTTP.get('/v1/opus/objectives').then(res => {
        this.objectives = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
  },
  created() {
    this.getObjs();
    this.getItems();
  },
  watch: {
    perPage() {
      this.pagination.current = 1
      this.getItems();
    },
  }
};
</script>

<style scoped></style>
